import { render } from "./SalaryReportsView.vue?vue&type=template&id=5b2c588b"
import script from "./SalaryReportsView.vue?vue&type=script&lang=js"
export * from "./SalaryReportsView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__